import { createRequestUrl } from '../../utils/request-url-helper';
export const SearchShowsApiPath = '/search/shows';
export const searchShows = async (axios, searchTerm = '', mediaType, pageSize, next) => {
  const requestUrl = createRequestUrl(SearchShowsApiPath, {
    searchTerm,
    mediaType,
    pageSize,
    next
  });
  const {
    data
  } = await axios.get(requestUrl);
  return data.data;
};